module.exports = __webpack_public_path__ + "media/components/assets/icons/close-5f6b7513bdeadb027cb57f6230c6d728.svg";